import { render, staticRenderFns } from "./CompPlanLevel.vue?vue&type=template&id=2e85de3f&scoped=true&"
import script from "./CompPlanLevel.vue?vue&type=script&lang=js&"
export * from "./CompPlanLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e85de3f",
  null
  
)

export default component.exports